import React from "react";
import {
  ContentsFlexWrap,
  FooterInformation,
  LogoLink,
  NavContentsWrap,
  NavContents,
  NavItem,
  NavItemLink,
  FooterSection,
  LinkButtonWrap,
  PCLinkListWrap,
  StyledLink,
  Wrap,
  LinkListWrap,
  SPLinkListWrap,
  LogoImg,
  NumberLabel,
  SPNumberLabelWrap,
  NumberLabelWrap,
  CopyLight,
} from "./elements";
import { MenuLabelList } from "../Header";
import Logo from "../../assets/images/bestvalue.png";

export const Footer: React.FC = React.memo(() => {
  return (
    <FooterSection>
      <Wrap>
        <SPLinkListWrap>
          {/* <LinkButtonWrap>
            <StyledLink isline={false}>申し込みはこちら</StyledLink>
          </LinkButtonWrap> */}
          <LinkButtonWrap>
            <StyledLink href="https://lin.ee/qHqIHr6" isline>
              LINE登録はこちら
            </StyledLink>
          </LinkButtonWrap>
        </SPLinkListWrap>
        <ContentsFlexWrap>
          <FooterInformation>
            <PCLinkListWrap>
              {/* <LinkButtonWrap>
                <StyledLink isline={false}>申し込みはこちら</StyledLink>
              </LinkButtonWrap> */}
              <LinkButtonWrap>
                <StyledLink href="https://lin.ee/qHqIHr6" isline>
                  LINE登録はこちら
                </StyledLink>
              </LinkButtonWrap>
            </PCLinkListWrap>
            <LinkListWrap>
              <LogoLink>
                <LogoImg alt="logo" src={Logo} />
              </LogoLink>
            </LinkListWrap>
            <NumberLabelWrap>
              <NumberLabel>福岡県公安商発行</NumberLabel>
              <NumberLabel>　第901132310077号</NumberLabel>
              <CopyLight>© 2024 BestValue Inc.</CopyLight>
            </NumberLabelWrap>
          </FooterInformation>
          <NavContentsWrap>
            <NavContents>
              {MenuLabelList.map((item) => (
                <NavItem key={item.label}>
                  <NavItemLink to={item.link}>{item.label}</NavItemLink>
                </NavItem>
              ))}
            </NavContents>
          </NavContentsWrap>
          <SPNumberLabelWrap>
            <NumberLabel>福岡県公安商発行</NumberLabel>
            <NumberLabel>　第901132310077号</NumberLabel>
            <CopyLight>© 2024 BestValue Inc.</CopyLight>
          </SPNumberLabelWrap>
        </ContentsFlexWrap>
      </Wrap>
    </FooterSection>
  );
});

Footer.displayName = "Footer";
